var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNamecard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 18.511h8M10 16h4M3 2h18v20H3V2Zm7.2 4.8c0 2.4 3.6 2.4 3.6 0s-3.6-2.4-3.6 0ZM16 13c0-4.333-8-4.333-8 0h8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamecard2);
export default __webpack_public_path__ + "static/media/namecard_2.37fbc47780f146678251f7f61be43e81.svg";
export { ForwardRef as ReactComponent };